import React, { useRef } from "react";
import TheGreatSage from "../maiyashree/TheGreatSage";
import AshramaFaculty from "../maiyashree/AshramaFaculty";
import AshramaBenefits from "../maiyashree/AshramaBenefits";
import FinestKnowledge from "../maiyashree/FinestKnowledge";
import ContactUs from "../common/ContactUs";
import SahajYogaCard from "../common/SahajYogaCard";
import HeaderOnly from "../common/HeaderOnly";
import Footer from "../common/Footer";
import Hero from "../maiyashree/Hero";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Maiyashree = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const section = document.getElementById(location.hash.substr(1));
      if (section) {
        window.scrollTo({
          top: section.offsetTop,
          behavior: "smooth",
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  const myRef = useRef(null);
  const scrollToRef = () => {
    if (myRef.current) {
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      {/* <Hero /> */}
      <HeaderOnly />
      <TheGreatSage />
      <AshramaFaculty />
      <AshramaBenefits />
      <ContactUs ContactUsREf={myRef}/>
      <SahajYogaCard click={scrollToRef} />
      <Footer />
    </>
  );
};

export default Maiyashree;
